module.exports = __webpack_public_path__ + "img/g1.5ae6dd23.jpg";